import React, { useState, useEffect } from 'react';
import './App.css';
import ConnectButton from './components/ConnectButton';
import TokenStats from './components/TokenStats';
import MyBalance from './components/MyBalance';
import TokenBridge from './components/TokenBridge';

function App() {
  const [isConnected, setIsConnected] = useState(!!localStorage.getItem('connectedAccount'));

  const handleConnectionStatus = (status) => {
    setIsConnected(status);
  };

  return (
    <div className="App bg-white min-h-screen flex flex-col items-center py-10">
      <header className="w-full max-w-5xl px-6">
        <div className="flex justify-end mb-6">
          <ConnectButton handleConnectionStatus={handleConnectionStatus} />
        </div>
        {isConnected ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
              <TokenStats />
              <MyBalance />
            </div>
            <div className="mt-6">
              <TokenBridge />
            </div>
          </>
        ) : (
          <div className="token-card bg-white shadow-lg rounded-lg p-6 w-full text-center">
            <h3 className="text-xl font-semibold mb-4">Please connect your wallet to access the ADBYTES token portal.</h3>
            <p className="text-lg font-medium mb-4">
              Features available:
            </p>
            <ul className="list-disc list-inside space-y-2 text-center">
              <li className="text-gray-700">View your wallet balance</li>
              <li className="text-gray-700">View global supply and network stats</li>
              <li className="text-gray-700">Cross-chain token bridge</li>
              <li className="text-gray-700">(more coming soon)</li>
            </ul>
          </div>
        )}
      </header>
    </div>
  );
}

export default App;
